<script lang="ts">
    import { getContext, onDestroy } from "svelte";
    import { inviteUserActivated } from "../../../Stores/MenuStore";
    import ActionBarButton from "../ActionBarButton.svelte";
    import LL from "../../../../i18n/i18n-svelte";
    import { analyticsClient } from "../../../Administration/AnalyticsClient";
    import ShareIcon from "../../Icons/meta/ShareIcon.svelte";
    import GuestSubMenu from "../../Menu/GuestSubMenu.svelte";
    import { showFloatingUi } from "../../../Utils/svelte-floatingui-show";

    interface Props {
        first?: boolean;
        last?: boolean;
        classList?: string;
    }

    let { first = undefined, last = undefined, classList = undefined }: Props = $props();

    let closeFloatingUi: (() => void) | undefined = undefined;
    let triggerElement: HTMLElement | undefined = $state(undefined);

    const inProfileMenu = getContext("profileMenu");

    function closeInviteMenu(): void {
        // Reset the handle before closing: close() calls back into onClose synchronously.
        const close = closeFloatingUi;
        closeFloatingUi = undefined;
        close?.();
    }

    function showInviteScreen() {
        if (closeFloatingUi) {
            closeInviteMenu();
        } else if (triggerElement) {
            analyticsClient.trackAdminEvent("invite.opened");
            closeFloatingUi = showFloatingUi(
                triggerElement,
                GuestSubMenu,
                {},
                {
                    placement: "bottom-end",
                },
                12,
                false,
                true,
                () => {
                    closeFloatingUi = undefined;
                },
            );
        }
    }

    // The popup is rendered by FloatingUiPopupList at the root of the app, so it outlives this
    // component. The action bar is unmounted whenever the chat or the map editor leaves less than
    // 285px of room, which would otherwise strand the popup with no way to close it.
    onDestroy(closeInviteMenu);
</script>

{#if $inviteUserActivated}
    {#if !inProfileMenu}
        <ActionBarButton
            boldLabel={true}
            hideIconInActionBar={false}
            onclick={showInviteScreen}
            bind:wrapperDiv={triggerElement}
            bgColor="rgba(255, 255, 255, 0.1)"
            {first}
            {last}
            {classList}
            ariaLabel="Пригласить"
            dataTestId="shareitem"
        >
            <ShareIcon />
        </ActionBarButton>
    {:else}
        <ActionBarButton
            hideIconInActionBar={false}
            onclick={showInviteScreen}
            bind:wrapperDiv={triggerElement}
            bgColor="rgba(255, 255, 255, 0.1)"
            classList="hidden narrow:flex {classList}"
            label={$LL.menu.invite.share()}
            ariaLabel="Пригласить"
        >
            <ShareIcon strokeWidth="0.1" />
        </ActionBarButton>
    {/if}
{/if}
